import Translation from "components/Translation"
import getConfig from "next/config"
import { useState } from "react"
import { ServiceItem } from "types/service"
import { toCurrency } from "utils/string-localization-helper"

type ServiceCardPreviewProps = {
    service: ServiceItem
    primary_color: string
}

export default function ServiceCardPreview(props: ServiceCardPreviewProps) {
    const {
        service,
        primary_color
    } = props
    const [is_hover, toggleHover] = useState<boolean>(false)
    const { NEXT_PUBLIC_STATIC_DOMAIN } = getConfig().publicRuntimeConfig

    return (
        <div
            className="w-11/12 mx-auto mb-[2px] px-[2px] py-[2px] rounded-[2px] cursor-pointer betterhover:hover:text-white"
            onMouseEnter={() => {
                toggleHover(true)
            }}
            onMouseLeave={() => {
                toggleHover(false)
            }}
            style={{
                backgroundColor: is_hover ? primary_color : `#F5F9FD`,
                borderColor: is_hover ? `${primary_color}40` : `transparent`
            }}
        >
            <div
                className="flex flex-col gap-[2px] text-left"
                id={service?.id}
            >
                <div className="flex flex-row items-center justify-between gap-[2px]">
                    <img
                        className="rounded w-5 h-5"
                        src={
                            service?.image_url ||
                            `https://${NEXT_PUBLIC_STATIC_DOMAIN}/images/location/location_fallback.jpg`
                        }
                        alt={service?.id}
                    />
                    <div className="flex flex-col flex-grow gap-[2px] betterhover:hover:text-white items-stretch">
                        <div className="flex flex-row justify-between items-center text-[3px]">
                            <h4 className="font-bold leading-[3px]">
                                {service?.name}
                            </h4>
                            <div
                                className="flex bg-white py-[1px] text-center justify-center items-center align-middle px-[3px] w-[36px]"
                                style={{
                                    border: '1px solid rgba(48, 59, 239, 0.1)',
                                    borderRadius: '23px',
                                }}
                            >
                                <span
                                    className="font-medium"
                                    style={{
                                        color: '#4B95B7',
                                    }}
                                >
                                    {toCurrency(
                                        service?.price as number
                                    )}
                                </span>
                            </div>
                        </div>
                        <div className="flex gap-[4px] items-center text-[2px]">
                            <Translation
                                content_key="booking.x_minutes"
                                content_values={{ val: service?.duration as number }}
                                render_as="p"
                                className="not-italic font-medium"
                            />
                            <div
                                className="h-[1px] w-[1px] bg-blue-900 mt-[1px]"
                                style={{ borderRadius: '50%' }}
                            />
                            <Translation
                                content_key='booking.x_staff'
                                content_values={{ staff_count: service.staff.length }}
                                render_as="p"
                                className='not-italic font-medium'
                            />
                        </div>
                    </div>
                </div>
                <p className="font-medium leading-[4px] text-[2px]">
                    {service?.description}
                </p>
            </div>
        </div>
    )
}